import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';

/**
 * How many locations each identity can access, for the Location Users list
 * and the office profile's Location Admins tab.
 *
 * A separate query from the rows because the counts live in
 * organization-service: the rows must not wait on it, and must not fail with
 * it. An id with no entry in `countsById` is one whose count has not arrived.
 *
 * @param {string[]} identityIds - Any number; the service batches past
 *   organization-service's id cap.
 */
export const useGetIdentityLocationCounts = (identityIds) => {
  const { data, isError } = useQuery({
    queryKey: usersKeys.identityLocationCounts(identityIds),
    queryFn: () => UsersService.getIdentityLocationCounts(identityIds),
    enabled: identityIds.length > 0,
    retry: false,
  });

  return {
    countsById: data ?? {},
    isError,
  };
};
